import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import About from './pages/About';
import Home from './pages/Home';
import Navbar from './components/navbar';
import AdminHome from './pages/AdminHome';
import VotingResults from './pages/VotingResults';
import CurrentResults from './pages/CurrentResults';

function App() {
  return (
    <BrowserRouter>
      <Navbar/>
      <Routes>
        <Route index element={<Home/>}/>
          <Route path="Login" element={<Login />} />
          <Route path="About" element={<About />} />
          <Route path="AdminHome" element={<AdminHome />} />
          <Route path="VotingResults" element={<VotingResults />} />
          <Route path="CurrentResults" element={<CurrentResults />} />
      </Routes>
    </BrowserRouter> 
  );
}

export default App;
